<template>
  <div class="center">
    <!--弹窗-->
    <div class="toast-bg" v-show="loadingFlag">
      <div class="toast-me middle toast-me2">
        <img src="../assets/img/loading.gif" alt="" />
      </div>
    </div>
    <!--弹窗-->
    <div class="toast-bg" v-show="detailFlag">
      <div class="toast-me middle">
        <div class="toast-tit">您的预约登记已成功</div>
        <hr class="toast-line" />
        <div class="toast-main toast-main2">
          <div class="toast-text">您的预约登记号为：{{ RegisNumber }}</div>
          <div class="toast-text">
            为您提供的服务是：
            <span class="toast-blue-span">{{ shopName }}</span>，地址： <span class="toast-blue-span">{{ shopAddr
            }}</span>,<br />联系电话：
            <span class="toast-blue-span">{{ shopNum }}</span>
          </div>
          <div class="toast-text">
            请您记录预约登记号并在送修产品时向前台出示
          </div>
        </div>
        <div class="toast-main toast-main2">
          <div>
            <img class="qrcode-img" src="../assets/img/202305230001_1280_toShop.jpg" />
          </div>
          <div class="toast-text">
            扫码关注「索尼中国 售后服务」微信公众号，及时获取服务进度及更多资讯。
          </div>
        </div>
        <div class="question-btns" style="background: none">
          <a href="javascript:" class="submit-btn" @click="detailFlag = false">点击关闭</a>
        </div>
      </div>
    </div>
    <div class="main-wrap">
      <div class="detail-page-nav">
        <a href="javascript:">首页
          <i> &gt; </i>
        </a>
        <a href="javascript:">在线预约及查询
          <i> &gt; </i>
        </a>
        <a href="javascript:" class="active">预约到店</a>
      </div>
      <div class="banner">
        <img src="../assets/img/toShop-banner.png" alt="" />
      </div>
      <div class="mainContent">
        <div class="show-part">
          <div class="reservation-category">请选择预约类别</div>
          <div class="products">
            <span>产品类别：</span>
            <a href="javascript:" :class="[{ active: index === productIndex }]" @click="selectProduct(index, item.type)"
              v-for="(item, index) in productTypes" :key="index">{{ item.name }}</a>
          </div>
          <div class="products">
            <span>服务内容：</span>
            <a href="javascript:" :class="[{ active: index === serviceIndex }]"
              @click="selectService(index, item.reasonCode, item.properties)" v-for="(item, index) in serviceType"
              :key="index">{{ item.name }}</a>
          </div>
          <div class="a-groups">
            <a href="javascript:" :class="['agree', { check2: checkA }]" @click="checkFun" aria-label="agree"></a>
            <!-- 20210720_update -->
            <!-- <a href="https://www.sony.com.cn/privacy/terms.html"  target="_blank" class="download-a">您已经了解《索尼产品顾客个人信息隐私政策》</a> -->
            <a href="https://www.sony.com.cn/privacy/terms.html" target="_blank" class="download-a">本人已了解同意《索尼隐私政策》</a>
            <span class="a-groups-span">如预约液晶电视或家庭影院上门服务,请点
              <a href="https://service.sony.com.cn/best/index.html#/" class="download-a2">击此处</a>
            </span>
          </div>
        </div>
      </div>
      <div class="hide-part" v-show="formPart">
        <div class="mainContent">
          <div class="reservation-category">请填写个人信息</div>
          <div class="input-groups">
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">个人地址：</span>
              </div>
              <div class="item-right fl">
                <div class="select-wrap select-wrap2">
                  <select name="" v-model="provinceCode" style="margin-right: 20px" @change="selectProvince()">
                    <option disabled value="default">请选择省</option>
                    <option :value="item.provinceid" v-for="(item, index) in proviceList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <select name="" v-model="cityCode" style="margin-right: 20px" @change="selectCity()">
                    <option disabled value="default">请选择市</option>
                    <option :value="item.cityid" v-for="(item, index) in cityList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <select name="" v-model="districtCode" @change="selectDistrict()" style="margin-right: 20px">
                    <option disabled value="default">请选择区</option>
                    <option :value="item.areaid" v-for="(item, index) in districList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>

                  <select name="" v-model="townCode" @change="getAsc()">
                    <option disabled value="default">请选择乡镇</option>
                    <option :value="item.townid" v-for="(item, index) in townList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="item-two">
                  <input type="text" placeholder="详细地址" class="detail-addr" maxlength="50" v-model="detailAddr" />
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">维修站：</span>
              </div>
              <div class="item-right fl">
                <div class="select-wrap clearfix" style="width: auto">
                  <select name="" style="width: 300px" v-model="serviceSite" @change="setShop">
                    <option disabled value="default">请选择</option>
                    <option :value="item.ascid" v-for="(item, index) in toShopAscList" :key="index">
                      {{ item.ascname }}
                    </option>
                  </select>
                  <span class="site-tip">
                    现仅开放此站到站服务预约，其余站点功能开发中</span>
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">您的姓名：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="name-input" v-model="name" />
              </div>
              <div class="gender fl" v-for="(item, index) in genderList" :key="index">
                <a href="javascript:" @click="radioSelect(item.sex, index)">
                  <span :class="['little-dot', { active: misterFlag === index }]"></span>
                </a>
                <span class="gender-span">{{ item.name }}</span>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">验证码：</span>
              </div>
              <div class="item-left verification-input fl">
                <input type="text" class="name-input" v-model="verificationNum" />
                <img :src="imgsrc" alt="" @click="refreshImg" />
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">手机：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="number-input" v-model="mobile" />
              </div>
              <div class="item-right fl">
                <span class="text">电话：</span>
                <input type="text" class="tele-input1" />
                <span class="short-line"></span>
                <input type="text" class="tele-input2" />
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">短信验证码：</span>
              </div>
              <div class="item-right fl">
                <input class="number-input" v-model="smsCode" ref="mobile" />
              </div>
              <div class="item-right fl">
                <div :class="[phoneVerFlag ? 'vercode_disable' : 'vercode']" @click="getPhoneVerif">
                  {{ phoneVerMessage }}
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star"></span>
                <span class="item-label">邮箱：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="number-input" v-model="email" />
              </div>
            </div>
          </div>
          <div class="reservation-info">
            <div class="reservation-category">请填写预约信息</div>
            <div class="input-groups">
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star">*</span>
                  <span class="item-label">到店时间：</span>
                </div>
                <div class="item-right fl" style="width: 1006px">
                  <div class="products products-week" style="margin-bottom: 0">
                    <a href="javascript:" :class="{ active: weekIndex === index }"
                      @click="seletWeekDay(index, item.year)" v-for="(item, index) in weekList" :key="index">{{
                        item.year }}<br />{{ item.week }}</a>
                  </div>
                  <div class="period">
                    <div class="period-img">
                      <img src="../assets/img/gray-sanjiao.png" alt="" />
                    </div>
                    <div class="period-box">
                      <div class="period-bg clearfix">
                        <div class="day-wrap">
                          <span :class="{ active: dayIndex === index }" v-for="(item, index) in oneDayList" :key="index"
                            @click="selectDay(index)">{{ item.tit }}</span>
                        </div>
                        <div v-show="daytimeFlag">
                          <div class="morning" v-show="dayFlag">
                            <a href="javascript:" :class="[
                              { gray: item.count === 4 },
                              { active: morningIndex === index },
                            ]" v-for="(item, index) in morningList" @click="morningCheck(index, item)" :key="index">
                              <div class="period-div">
                                {{ item.showTime }}
                                <p v-show="item.count === 4">预约已满</p>
                              </div>
                            </a>
                          </div>
                          <div class="afternoon" v-show="!dayFlag">
                            <a href="javascript:" :class="[
                              { active: afterindex === index },
                              { gray: item.count === 4 },
                            ]" v-for="(item, index) in afterList" @click="afterCheck(index, item)" :key="index">
                              <div class="period-div">
                                {{ item.showTime }}
                                <p v-show="item.count === 4">预约已满</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star">*</span>
                  <span class="item-label">产品型号：</span>
                </div>
                <div class="item-right fl" style="position: relative">
                  <input type="text" class="number-input" v-model="modelCode" @keyup="modelCodeFun" @blur="checkDI" />
                  <div class="reg-product" @click="handleRegProduct">
                    + 选择已注册产品
                  </div>
                  <ul class="ul-menu ul-menu-home" v-show="regProductFlag">
                    <li v-for="(item, index) in regProductDataList" @click="
                      selectRegPorduct(item.productModel, item.serialNumber)
                      " :key="index">
                      {{ item.productModel }}（序列号：{{ item.serialNumber }}）
                    </li>
                  </ul>
                  <ul class="ul-menu" v-show="modelulFlag">
                    <li v-for="(item, index) in modeList" @click="selectMode(item.enName)" :key="index">
                      {{ item.enName }}
                    </li>
                  </ul>
                </div>
                <div class="fl item-left">
                  &nbsp; &nbsp; &nbsp;
                  <span class="star">*</span>
                  <span class="item-label">序列号：</span>
                </div>
                <div class="item-right fl">
                  <input type="text" class="number-input" v-model="serialNum" />
                  <div class="serial-number-a">
                    查询产品型号和序列号确认方法请点击
                    <a target="_blank" href="https://www.sony.com/zh-cn/electronics/support/articles/00184953">这里</a>
                  </div>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star"></span>
                  <span class="item-label">购机日期：</span>
                </div>
                <div class="item-right fl">
                  <DatePicker type="date" class="dateWrap" @on-change="buyDate = $event" :options="optionsDis1"
                    :value="buyDate" placeholder="购机日期" style="width: 200px"></DatePicker>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: 44px">
                  <span class="star">*</span>
                  <span class="item-label">保修类型：</span>
                </div>
                <div class="products products2 item-right fl">
                  <a href="javascript:" :class="{ active: warrantIndex === index }"
                    v-for="(item, index) in warrantyList" @click="warrantCheck(index, item.code)" :key="index">{{
                      item.name }}</a>
                </div>
                <div class="item-right fl Terms">
                  <span>维修站将基于事实和相关 <br />法律法规作出最终判断</span>
                  <a target="_blank"
                    href="https://service.sony.com.cn/content/casch/serviceinfo/servicepolicy.html">产品保修条款</a>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: normal">
                  <span class="star">*</span>
                  <span class="item-label">服务要求/ 症状描述：</span>
                </div>
                <div class="item-right fl textarea-wrap">
                  <textarea name="" id="" cols="" rows="" v-model="trouble">
                  </textarea>
                </div>
              </div>
            </div>
            <div class="notice notice2">
              <div class="notice_tit fl">注意事项</div>
              <div class="notice-list">
                <ul>
                  <li>
                    ●
                    您的预约登记成功后将收到由索尼发出的预约确认短信，请注意查收；
                  </li>
                  <li>
                    ●
                    请您在预约时间段内到站，并在站内叫号机上索取“已预约用户”的等候牌，您将被优先安排服务。
                  </li>
                  <li>
                    ●
                    若您未能在预约时间段内到站，您需重新预约或到站后取号排队等候服务；
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="question-btns">
          <a href="javascript:" class="back-btn" @click="resetData">重置</a>
          <a href="javascript:" class="submit-btn" @click="addQuery">提交</a>
        </div>
      </div>
    </div>

    <systemNotice></systemNotice>
    <login></login>
  </div>
</template>
<script>
// @ is an alias to /src
import login from "../components/login"
import systemNotice from "../components/system-notice"
import api from "../common/utils/api";
import { JSEncrypt } from "jsencrypt";
import {
  getDay,
  sevenDays,
  getCode,
  regs,
  isMobileDevice,
  Condition,
} from "../common/utils/pageCtents";
import http from "axios";
let dayInit = getDay(2, "-");
// 液晶电视-液晶电视底座安装：T   液晶电视-液晶电视挂墙安装：I  液晶电视-维修：S   液晶电视-调试：T
export default {
  components: { systemNotice, login },
  data() {
    return {
      optionsDis1: {
        disabledDate(date) {
          return date.getTime() > new Date().getTime();
        }
      },
      PUBLIC_KEY:
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCLwK1xP5uTgoJshPCtJxVuTq36JIh05HBsfGshE71oR9syteqAJcupa76O+dm9cI3iCiMHGdo7mhqAt/haiVrBHOamxe5OYaAK06waKMBct+O2SC1F6dY7voIA0PPw0DSnTD1FIHslwmw1ccB0/c9Hr5ytQ9n3BGUlRRrSZJKAZQIDAQAB",
      shopName: "",
      shopAddr: "",
      shopNum: "",
      conditionFlag: "",
      loadingFlag: false,
      RegisNumber: "",
      detailFlag: false,
      productType: "",
      productTypes: [
        {
          name: "数码产品",
          type: "E",
        },
        {
          name: "音频",
          type: "A",
        },
      ],
      // 液晶电视
      repairProperties: "",
      reserveReason: "",
      serviceType: [],
      serviceType1: [
        {
          name: "维修",
          reasonCode: "124",
          properties: "W",
        },
      ],
      // 音频
      serviceType2: [
        {
          name: "维修",
          reasonCode: "124",
          properties: "W",
        },
      ],
      checkA: false,
      formPart: false,
      reservationCheck: true,
      daytimeFlag: false,
      dayIndex: 0,
      oneDayList: [
        {
          tit: "上午",
          id: 0,
        },
        {
          tit: "下午",
          id: 1,
        },
      ],
      genderList: [
        {
          name: "先生",
          sex: "sir",
        },
        {
          name: "女士",
          sex: "lady",
        },
      ],
      trouble: "",
      afterindex: null,
      morningIndex: null,
      productIndex: null,
      serviceIndex: null,
      imgsrc: "",
      verificationNum: "",
      weekIndex: null,
      dayFlag: true,
      misterFlag: null,
      reserveType: "S", // 到店
      SelectData: {},
      proviceList: [],
      cityList: [],
      districList: [],
      townList: [],
      addressList: [],
      selectIndex: null,
      provinceCode: "default",
      cityCode: "default",
      districtCode: "default",
      townCode: "default",
      serviceSite: "default",
      serviceFlag2: false,
      selectUL: true,
      cityUrl: "",
      districUrl: "",
      weekList: [],
      morningList0: [
        {
          customerReserveDate: `${dayInit} 10:30`,
          count: 0,
          showTime: "10:30-11:00",
          time: `10:30`,
        },
        {
          customerReserveDate: `${dayInit} 11:00`,
          count: 0,
          showTime: "11:00-11:30",
          time: `11:00`,
        },
        {
          customerReserveDate: `${dayInit} 11:30`,
          count: 0,
          showTime: "11:30-12:00",
          time: `11:30`,
        },
      ],
      morningList: [],
      afterList0: [
        {
          customerReserveDate: `${dayInit} 13:00`,
          count: 0,
          showTime: "13:00-13:30",
          time: `13:00`,
        },
        {
          customerReserveDate: `${dayInit} 13:30`,
          count: 0,
          showTime: "13:30-14:00",
          time: `13:30`,
        },
        {
          customerReserveDate: `${dayInit} 14:00`,
          count: 0,
          showTime: "14:00-14:30",
          time: `14:00`,
        },
        {
          customerReserveDate: `${dayInit} 14:30`,
          count: 0,
          showTime: "14:30-15:00",
          time: `14:30`,
        },
        {
          customerReserveDate: `${dayInit} 15:00`,
          count: 0,
          showTime: "15:00-15:30",
          time: `15:00`,
        },
        {
          customerReserveDate: `${dayInit} 15:30`,
          count: 0,
          showTime: "15:30-16:00",
          time: `15:30`,
        },
        {
          customerReserveDate: `${dayInit} 16:00`,
          count: 0,
          showTime: "16:00-16:30",
          time: `16:00`,
        },
        {
          customerReserveDate: `${dayInit} 16:30`,
          count: 0,
          showTime: "16:30-17:00",
          time: `16:30`,
        },
        {
          customerReserveDate: `${dayInit} 17:00`,
          count: 0,
          showTime: "17:00-17:30",
          time: `17:00`,
        },
        {
          customerReserveDate: `${dayInit} 17:30`,
          count: 0,
          showTime: "17:30-18:00",
          time: `17:30`,
        },
        {
          customerReserveDate: `${dayInit} 18:00`,
          count: 0,
          showTime: "18:00-18:30",
          time: `18:00`,
        },
        {
          customerReserveDate: `${dayInit} 18:30`,
          count: 0,
          showTime: "18:30-19:00",
          time: "18:30",
        },
        {
          customerReserveDate: `${dayInit} 19:00`,
          count: 0,
          showTime: "19:00-19:30",
          time: `19:00`,
        },
        {
          customerReserveDate: `${dayInit} 19:30`,
          count: 0,
          showTime: "19:30-20:00",
          time: `19:30`,
        },
        {
          customerReserveDate: `${dayInit} 20:00`,
          count: 0,
          showTime: "20:00-20:30",
          time: `20:00`,
        },
      ],
      afterList: [],
      warrantyType: "",
      warrantyList: [
        {
          name: "保外",
          code: "O",
          id: 0,
        },
        {
          name: "保内",
          code: "I",
          id: 1,
        },
        {
          name: "延保",
          code: "E",
          id: 2,
        },
      ],
      warrantIndex: null,
      // 提交预约的字段
      detailAddr: "",
      name: "",
      email: "",
      mobile: "",
      customerReserveDate: "",
      reserveDateRange: "", // A(上午) P（下午），
      gender: "",
      serialNum: "",
      modelCode: "",
      modeList: [],
      modelulFlag: false,
      buyDate: "",
      phoneVerMessage: "获取验证码", //获取验证码描述
      phoneTime: 60, //验证码多久可以再次获取 默认60s
      phoneVerFlag: false, // 获取验证码状态
      smsCode: "", //短信验证码
      regProductDataList: [], //已注册产品列表
      regProductFlag: false, //是否展示已注册产品列表
      isChoosedModel: false, // 是否选择了下拉框中的产品型号
      toShopAscList: [
        {
          ascid: '9e8d1bcf-dd69-ea11-a87b-0017fa02f25d',
          ascname: '索尼服务体验中心上海旗舰店',
          ascAddress: '上海市淮海中路901号',
          ascTel: '021-56187001'
        },
        {
          ascid: '00901bcf-dd69-ea11-a87b-0017fa02f25d',
          ascname: '索尼服务体验中心南京旗舰店',
          ascAddress: '秦淮区建康路1号南京鹏欣水游城F1-W08店铺',
          ascTel: '025-84277286'
        },
        {
          ascid: 'f64afbc1-3230-eb11-a813-0017fa0282e4',
          ascname: '索尼服务体验中心杭州旗舰店',
          ascAddress: '杭州市上城区平海路124号',
          ascTel: '0571-87818807'
        },
        {
          ascid: 'ce8f1bcf-dd69-ea11-a87b-0017fa02f25d',
          ascname: '索尼服务体验中心广州旗舰店',
          ascAddress: '广州市天河区天河路228号正佳广场3楼3B035-40/059',
          ascTel: '020-87558848'
        },
        {
          ascid: '434f16a0-5326-ed11-b83c-0017fa03fc53',
          ascname: '索尼服务体验中心武汉旗舰店',
          ascAddress: '武汉市武昌区武珞路628号武汉梦时代广场负一楼A区A-004/005/006',
          ascTel: '027-87879879'
        },
        {
          ascid: '930d0c86-47fb-ed11-8848-0017fa02377b',
          ascname: '索尼服务体验中心重庆旗舰店',
          ascAddress: '重庆市九龙坡区谢家湾正街45号万象城二期NL280',
          ascTel: '023-63630180'
        },
        {
          ascid: '04901bcf-dd69-ea11-a87b-0017fa02f25d',
          ascname: '深圳深业上城DQRC',
          ascAddress: '深圳市福田区华富街道皇岗路5001号深业上城（南区）一期2层S224商铺',
          ascTel: '0755-23611644'
        },
        {
          ascid: '99d2c05a-2b73-ea11-a8ac-0017fa02fd57',
          // ascid: 'e62fff92-8ac2-ea11-a812-0017fa0282e4',
          ascname: '索尼服务体验中心苏州旗舰店',
          ascAddress: '苏州市金阊街道广济南路369号（苏州万象天地S180N+S253N号商铺）SonyStore 苏州万象天地店二楼',
          ascTel: '0512-65239536'
        },
        {
          ascid: 'f68f1bcf-dd69-ea11-a87b-0017fa02f25d',
          // ascid: 'e62fff92-8ac2-ea11-a812-0017fa0282e4',
          ascname: '成都索尼特约维修站 -人民南路店',
          ascAddress: '人民南路4段3号来福士广场01层59-1号 Sony Store 索尼服务体验中心',
          ascTel: '028-85484567'
        },
      ], //预约到店维修站
    };
  },
  methods: {
    /**
     * 获取短信验证码
     */
    getPhoneVerif() {
      if (this.phoneVerFlag) {
        return;
      }
      var phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;

      this.phoneVerFlag = true;
      if (this.verificationNum === "") {
        this.showModel("请填写图形验证码");
        this.phoneVerFlag = false;
        return;
      }
      if (this.mobile === "") {
        this.showModel("请输入手机号");
        this.phoneVerFlag = false;
        return;
      }
      if (!phoneReg.test(this.mobile)) {
        this.showModel("请输入正确的手机号");
        this.phoneVerFlag = false;
        return;
      }
      if (this.serviceSite === "default") {
        this.showModel("请选择维修站");
        this.phoneVerFlag = false;
        return;
      }
      //数据加密
      let timeStamp = new Date().getTime();
      let url = api.reservation.getSmsCode();
      let encryptor = new JSEncrypt();
      encryptor.setPublicKey(
        "-----BEGIN PUBLIC KEY-----" +
        this.PUBLIC_KEY +
        "-----END PUBLIC KEY-----"
      );
      var encrypted = encryptor.encrypt(this.mobile + "," + timeStamp);
      console.log("加密后数据:%o", encrypted);
      let data = {
        mobile: this.mobile,
        timeStamp: timeStamp,
        vaildCode: this.verificationNum,
        cipher: encrypted,
        organizationCode: this.serviceSite,
      };
      http.post(url, data).then((res) => {
        if (res.data.stateCode !== 1) {
          this.showModel(res.data.message);
          this.phoneVerFlag = false;
        } else {
          this.showModel("发送成功");
          this.times();
        }
      });
    },
    /**
     * 倒计时功能
     */
    times() {
      //开启倒计时
      this.timer = setInterval(() => {
        this.phoneTime--;
        this.phoneVerMessage = this.phoneTime + "s后可以重新获取";
        if (this.phoneTime === 0) {
          clearInterval(this.timer);
          this.phoneVerMessage = "获取验证码";
          this.phoneTime = 60;
          this.phoneVerFlag = false;
        }
      }, 1000);
    },

    setShop() {
      this.toShopAscList.forEach((item) => {
        if (item.ascid === this.serviceSite) {
          this.shopName = item.ascname;
          this.shopAddr = item.ascAddress;
          this.shopNum = item.ascTel;
          return false;
        }
      });
    },

    checkFun() {
      if (this.productType && this.reserveReason) {
        console.log("this.productType:", this.productType);
        console.log("this.serviceType:", this.serviceType);
        this.checkA = !this.checkA;
        this.formPart = !this.formPart;
      } else {
        this.$toast({
          show: true,
          message: "请选择预约信息!",
          position: "top",
          during: 3000,
        });
      }
    },
    selectProduct(index, type) {
      this.productType = type;
      this.productIndex = index;
      let attrStr = "serviceType" + Number(index + 1);
      this.serviceType = this[attrStr];
    },
    selectService(index, reasonCode, properties) {
      console.log("reasonCode:", reasonCode);
      this.repairProperties = properties;
      this.reserveReason = reasonCode;
      this.serviceIndex = index;
    },
    resetData() {
      this.isChoosedModel = false;
      this.verificationNum = "";
      this.detailAddr = "";
      this.provinceCode = "";
      this.cityCode = "";
      this.modeSpread = false;
      this.modelulFlag = false;
      this.gender = null;
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.reserveReason = "";
      this.customerReserveDate = "";
      this.reserveDateRange = "";
      this.modelCode = "";
      this.buyDate = "";
      this.serialNum = "";
      this.trouble = "";
      this.warrantyType = "";
      this.productType = "";
      this.repairProperties = "";
      this.provinceCode = "default";
      this.cityCode = "default";
      this.afterindex = null;
      this.morningIndex = null;
      this.weekIndex = null;
      this.misterFlag = null;
      this.productIndex = null;
      this.serviceIndex = null;
      this.selectIndex = null;
      this.warrantIndex = null;
      this.dayFlag = true;
      this.dayIndex = 0;
    },
    //DI品类的check
    checkDI() {
      // blur方法会在选择产品型号方法前面执行，所以这里进行下延迟判断
      setTimeout(() => {
        let modelCode = this.modelCode;
        //进行DI品类校验
        let url = api.reservation.getCheckDI();
        http({
          method: "POST",
          url: url,
          data: {
            modelCode: modelCode,
          },
        })
          .then((res) => {
            if (res.data.data != 1) {
              this.modelCode = "";
              this.$toast({
                show: true,
                message: "本型号暂未开通到店服务,不允许继续填入及提交",
                position: "top",
                during: 3000,
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }, 300);
    },
    // 产品型号的模糊查询
    modelCodeFun() {
      console.log("产品型号变量");
      let url = api.reservation.findProModel();
      let keyword = this.modelCode.trim().toUpperCase();
      if (keyword.length > 1) {
        http({
          method: "GET",
          url: url,
          params: {
            keyword: keyword,
          },
        })
          .then((res) => {
            if (res.data.returnData.Data && res.data.returnData.Data.length) {
              this.modeList = res.data.returnData.Data;
              this.modelulFlag = true;
            } else {
              this.modelulFlag = false;
            }
            console.log("产品型号：", res);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    selectMode(mode) {
      this.modelCode = mode;
      this.isChoosedModel = true;
      //进行DI品类校验
      let url = api.reservation.getCheckDI();
      http({
        method: "POST",
        url: url,
        data: {
          modelCode: this.modelCode,
        },
      })
        .then((res) => {
          if (res.data.data != 1) {
            this.modelCode = "";
            this.$toast({
              show: true,
              message: "本型号暂未开通到店服务,不允许继续填入及提交",
              position: "top",
              during: 3000,
            });
          } else {
            this.modelCode = mode;
            this.modelulFlag = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkSingle(value, type) {
      let reg = new RegExp(regs[type]);
      if (reg.test(value)) {
        return true;
      } else {
        return false;
      }
    },
    showModel(mes) {
      this.$toast({
        show: true,
        message: mes,
        position: "top",
        during: 3000,
      });
    },
    checkSpace(item) {
      if (!item.val) {
        this.showModel(item.message);
        return false;
      } else {
        let newVal = (item.val + "").trim();
        if (item.reg) {
          if (!this.checkSingle(newVal, item.reg)) {
            this.showModel(item.message);
            return false;
          }
        } else {
          if (!newVal) {
            this.showModel(item.message);
            return false;
          }
        }
      }
      return true;
    },
    checkInput() {
      // 上门地址
      if (
        this.provinceCode === "default" ||
        this.cityCode === "default" ||
        this.districtCode === "default"
      ) {
        this.showModel("请选择上门地址！");
        return false;
      }
      // 详细check
      let checkDatas = [
        {
          val: this.detailAddr,
          message: "请填写详细地址！",
        },
        {
          val: this.serviceSite,
          message: "请选择维修站！",
        },
        {
          val: this.name,
          message: "请填写姓名！",
        },
        {
          val: this.gender,
          message: "请填写您的性别！",
        },
        {
          val: this.mobile,
          message: "请填正确的手机号！",
          reg: "telPhone",
        },
        // {
        //   'val': this.customerReserveDate,
        //   'message': '请填选择预约日期！'
        // },
        {
          val: this.reserveDateRange,
          message: "请填选择预约日期或时段！",
        },
        {
          val: this.modelCode,
          message: "请填写产品型号！",
        },
        {
          val: this.serialNum,
          message: "请填写产品序列号！",
        },
        {
          val: this.buyDate,
          message: "请选择购机日期！",
        },
        {
          val: this.warrantyType,
          message: "请选择保修类型！",
        },
        {
          val: this.trouble,
          message: "请填写服务要求或症状描述！",
        },
        {
          val: this.verificationNum,
          message: "请填写图片验证码！",
        },
        {
          val: this.smsCode,
          message: "请填写短信验证码！",
        },
      ];
      for (let index in checkDatas) {
        // console.log('checkDatas[index]', checkDatas[index])
        if (!this.checkSpace(checkDatas[index])) {
          console.log("checkDatas[index]", checkDatas[index]);
          return false;
        }
      }
      return true;
    },
    // 添加预约
    addQuery() {
      let self = this;
      console.debug("customerID", localStorage.getItem("customerID"));
      if (this.reservationCheck) {
        if (this.checkInput()) {
          // 获取省市区label
          let provinceName = "";
          this.proviceList.forEach((item) => {
            if (item.provinceid == this.provinceCode) {
              provinceName = item.name;
            }
          });
          let cityName = "";
          this.cityList.forEach((item) => {
            if (item.cityid == this.cityCode) {
              cityName = item.name;
            }
          });
          let districtName = "";
          this.districList.forEach((item) => {
            if (item.areaid == this.districtCode) {
              districtName = item.name;
            }
          });
          let townName = "";
          this.townList.forEach((item) => {
            if (item.townid == this.townCode) {
              townName = item.name;
            }
          });
          this.loadingFlag = true;
          this.reservationCheck = false;
          let url = api.reservation.addBookService();
          console.log("=======" + this.customerReserveDate);
          var mytime = this.customerReserveDate.split(" ");
          var realtime = getDay(this.weekIndex + 1, "-") + " " + mytime[1];
          let data = {
            vaildCode: this.verificationNum.trim(),
            CustomerBean: {
              customercode: localStorage.getItem("customerID") || "",
              smsCode: this.smsCode,
              address:
                provinceName +
                cityName +
                districtName +
                townName +
                this.detailAddr.trim(),
              provinceID: this.provinceCode,
              cityID: this.cityCode,
              organizationCode: this.serviceSite,
              districtId: this.districtCode.trim(),
              // organizationCode:
              //   `${BASE_PATH}` === "development" || this.conditionFlag
              //     ? "66000"
              //     : this.serviceSite,
              naming: this.gender, // sir/lady
              customerName: this.name.trim(),
              email: this.email.trim(),
              phone: "", // 电话
              mobile: this.mobile.trim(), // 手机
            },
            ReserveBean: {
              reserveReason: this.reserveReason,
              organizationCode: this.serviceSite,
              // organizationCode:
              //   `${BASE_PATH}` === "development" || this.conditionFlag
              //     ? "66000"
              //     : this.serviceSite,
              reserveType: this.reserveType,
              //customerReserveDate: this.customerReserveDate, //
              customerReserveDate: realtime, //
              reserveDateRange: this.reserveDateRange, // A或P
              source: "3",
            },
            ReserveDtlBean: [
              {
                homeServiceDate: "", // 为空就可以
                modelCode: this.modelCode, // 产品型号
                purchaseDate: this.buyDate, // 到天就可以了
                serialNo: this.serialNum.trim(), // 序列号
                userTrouble: this.trouble.trim(),
                reserveType: this.reserveType,
                warrantyType: this.warrantyType,
                productType: this.productType,
                repairProperties: this.repairProperties,
                reserveReason: this.reserveReason,
                // 下面都可以为空
                addMemory: "",
                backupBySelf: "",
                canReplaceResume: "",
                clearPassword: "",
                extendWarranty: "",
                isReset: "",
                preRepairFee: "",
                suggestParts: "",
                isReturn: "Y", // 在页面上加一个勾选该字段的
              },
            ],
          };
          http
            .post(url, data)
            .then((res) => {
              this.loadingFlag = false;
              this.imgsrc = getCode();
              this.reservationCheck = true;
              let mes = res.data.message;
              let data = res.data.data;
              if (res.data.stateCode === 1) {
                this.RegisNumber = data;
                this.detailFlag = true;
                // setTimeout(() => {
                //   window.location.href = api.prd
                // }, 2000)
              } else {
                this.showModel(mes);
              }
            })
            .catch((error) => {
              this.loadingFlag = false;
              this.imgsrc = getCode();
              this.reservationCheck = true;
              this.showModel("预约失败，请稍后再试");
              console.log("error:", error.response);
            });
        }
      }
    },
    afterCheck(index, item) {
      if (item.count === 4) {
        return false;
      } else {
        console.log(item);
        this.afterindex = index;
        this.customerReserveDate = item.customerReserveDate;
        this.reserveDateRange = this.checkTime(item.time);
        console.log(this.customerReserveDate);
        console.log(this.reserveDateRange);
      }
    },
    morningCheck(index, item) {
      if (item.count === 4) {
        return false;
      } else {
        console.log(item);
        this.customerReserveDate = item.customerReserveDate;
        this.reserveDateRange = this.checkTime(item.time);
        this.morningIndex = index;
      }
    },
    refreshImg() {
      this.imgsrc = getCode();
    },
    warrantCheck(index, code) {
      this.warrantyType = code;
      this.warrantIndex = index;
    },
    getAppointment(year) {
      console.log("reservedate:", year);
      let url = api.reservation.queryDateRange();
      let that = this;
      return new Promise(function (resolve, reject) {
        http({
          method: "get",
          url: url,
          params: {
            reservedate: year,
            stationcode: that.serviceSite,
          },
          // data: ''
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch(() => {
            that.showModel("服务器出错了!");
          });
      });
    },
    checkTime(val) {
      let newval = val.substr(0, 2);
      if (newval <= 12) {
        return "A";
      } else {
        return "P";
      }
    },
    async seletWeekDay(index, year) {
      this.dayFlag = true;
      this.dayIndex = 0;
      this.daytimeFlag = true;
      this.morningIndex = null;
      this.afterindex = null;
      this.weekIndex = index;
      let res = await this.getAppointment(year);
      if (res.stateCode == 1) {
        let dateList = res.data;
        this.morningList = [];
        this.afterList = [];
        this.morningList0.forEach((item1) => {
          let newItem = {
            ...item1,
          };
          dateList.forEach((item2) => {
            let longTime = item2.date.substring(0, 19);
            let shortTime = item2.date.substring(11, 19);
            if (shortTime === newItem.time) {
              newItem.count = item2.count;
              newItem.customerReserveDate = longTime;
            }
          });
          this.morningList.push(newItem);
        });
        this.afterList0.forEach((item) => {
          let newItem = {
            ...item,
          };
          dateList.forEach((item2) => {
            let longTime = item2.date.substring(0, 19);
            let shortTime = item2.date.substring(11, 19);
            if (shortTime === newItem.time) {
              console.debug(item2.count)
              newItem.count = item2.count;
              newItem.customerReserveDate = longTime;
            }
          });
          this.afterList.push(newItem);
        });
      } else {
        this.morningList = this.morningList0;
        this.afterList = this.afterList0;
      }
      console.log(" this.morningList:", this.morningList);
      console.log(" this.afterList:", this.afterList);
    },
    selectDay(index) {
      this.morningIndex = null;
      this.afterindex = null;
      this.dayIndex = index;
      if (index === 0) {
        this.dayFlag = true;
      } else if (index === 1) {
        this.dayFlag = false;
      }
    },
    radioSelect(sex, index) {
      this.gender = sex;
      this.misterFlag = index;
    },
    getSelectVal(res) {
      this.proviceList = res;
      this.proviceList.forEach((a, b) => {
        if (this.provinceCode === a.childName) {
          let rets = this.initAddress(this.provinceCode);
          this.cityList = rets;
          this.cityList.forEach((item, index) => {
            if (this.cityCode === item.childName) {
              let rets2 = this.initAddress(this.cityCode);
              this.districList = rets2;
            }
          });
        }
      });
    },
    async initAddress(name) {
      let url = api.reservation.address();
      let list = await http({
        method: "get",
        url: url + name,
        data: {},
      });
      return list.data;
    },
    async selectAddress(value, index) {
      let code = this[value];
      console.log("code:", code);
      switch (index) {
        case 1:
          this.cityCode = "default";
          this.districtCode = "default";
          this.townCode = "default";
          this.districList = [];
          this.townList = [];
          let param1 = code + "_ProvinceNode.json";
          let rets1 = await this.initAddress(param1);
          this.cityList = rets1;
          break;
        case 2:
          this.districtCode = "default";
          this.townCode = "default";
          this.townList = [];
          let param2 = code + "_CityNode.json";
          let rets2 = await this.initAddress(param2);
          this.districList = rets2;
          break;
        case 3:
          this.townCode = "default";
          try {
            let param3 = code + "_TownNode.json";
            console.log("Try to load level 4 " + param3);
            let rets3 = await this.initAddress(param3);
            this.townList = rets3;
            // console.log('load town list: ', this.townList)
          } catch (err) {
            console.log("error " + JSON.stringify(err));
          }
          break;
        default:
      }
    },
    getCondition() {
      this.conditionFlag = Condition(this);
    },

    /**
     * 初始化获取省份
     */
    findProvince() {
      let url = api.reservation.findProvince();
      http.get(url).then((res) => {
        let data = res.data;
        if (data.stateCode === 1) {
          let provinceList = data.data;
          this.proviceList = provinceList;
        } else {
          this.proviceList = [];
        }
      });
    },

    /**
     * 选择省份获取城市
     */
    selectProvince() {
      let url = api.reservation.findCity() + "/" + this.provinceCode;
      http.get(url).then((res) => {
        let data = res.data;
        if (data.stateCode === 1) {
          let cityForm = data.data;
          this.cityList = cityForm;
        } else {
          this.cityList = [];
        }
        this.districList = [];
        this.townList = [];
        this.ASCList = [];
        this.serviceSite = "default";
        this.cityCode = "default";
        this.districtCode = "default";
        this.townCode = "default";
      });
    },

    /**
     * 选择城市获取乡区
     */
    selectCity() {
      let url =
        api.reservation.findDistinct() +
        "/" +
        this.cityCode +
        "?t=" +
        new Date().getTime();
      http.get(url).then((res) => {
        console.log(res.data);
        let data = res.data;
        if (data.stateCode === 1) {
          let districtForm = data.data;
          this.districList = districtForm;
        } else {
          this.districList = [];
        }
        this.townList = [];
        this.ASCList = [];
        this.serviceSite = "default";
        this.townCode = "default";
        this.districtCode = "default";
      });
    },

    /**
     * 选择乡区获取城镇
     */
    selectDistrict() {
      let url = api.reservation.findTown() + "/" + this.districtCode;
      //获取城镇
      http.get(url).then((res) => {
        let data = res.data;
        let townForm = data.data;
        this.townList = townForm;
        this.townCode = "default";
        this.serviceSite = "default";
        this.serviceSiteName = "";
        this.serviceTelephone = "";
        this.ASCList = [];
        if (this.townList.length == 0) {
          //无城镇数据，在乡区选择时获取维修站
          this.getAsc();
        }
      });
    },

    /**
     * 获取维修站
     */
    getAsc() {
      let params = {
        provinceId: this.provinceCode,
        cityId: this.cityCode,
        districtId: this.districtCode,
        townId: this.townCode === "default" ? "" : this.townCode,
        serviceCategory: this.productTypes[this.productIndex].serviceCategory,
      };
      var urlParams = Object.keys(params)
        .map(function (key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
      console.log(urlParams);
      let url = api.reservation.findAsc() + "?" + urlParams;
      http.get(url).then((res) => {
        console.log(res.data);
        let data = res.data;
        let ascForm = data.data;
        // this.ASCList = ascForm.filter(item => item.ascCode !== 'FF012' && item.ascCode !== 'FF013' && item.ascCode !== 'FF015')
        this.ASCList = ascForm;
        if (this.ASCList.length > 0) {
          this.serviceSite = this.ASCList[0].ascid;
          this.serviceSiteName = this.ASCList[0].ascmame;
          this.serviceTelephone = this.ASCList[0].telephone;
        } else {
          this.serviceSite = "default";
          this.serviceSiteName = "";
          this.serviceTelephone = "";
        }
      });
    },

    /**
     * 获取会员信息
     */
    getPersonalDetails() {
      let userInfo = JSON.parse(localStorage.getItem("user_details") || "null");
      let mobile = userInfo ? userInfo.telephone : "";
      let userAlias = userInfo ? (userInfo.realName || userInfo.userAlias) : "";
      this.name = userAlias;
      this.mobile = mobile;
    },

    /**
     * 获取已注册产品列表
     */
    getRegPorductList() {
      let url = api.member.productRegistrationHistory();
      http({
        method: "POST",
        url: url,
        data: {
          idToken: localStorage.getItem("oidc_id_token") || "",
          page: 0,
          pageSize: 50
        },
      }).then((res) => {
        console.info(res.data.data.productRegList);
        this.regProductDataList = res.data.data.productRegList;
      });
    },

    /**
     * 点击选择已注册产品
     */
    handleRegProduct() {
      let productList = this.regProductDataList || [];
      console.info(productList);
      if (productList.length == 0) {
        this.showModel("您暂无已注册产品");
        return;
      }
      this.regProductFlag = true;
    },

    /**
     * 选择已注册产品
     */
    selectRegPorduct(productModel, serialNumber) {
      console.info(productModel, serialNumber);
      if (productModel == "WH-1000XM4" || productModel == "WF-1000XM4") {
        this.modelCode = productModel;
        this.serialNum = serialNumber;
        this.regProductFlag = false;
        return;
      }
      //通配手机型号
      if (
        (productModel.indexOf("Xperia") != -1 ||
          productModel.indexOf("xperia") != -1) &&
        productModel !== "Xperia 1 IV 256GB" &&
        productModel !== "Xperia 1 IV 512GB" &&
        productModel !== "Xperia 1 V"
      ) {
        productModel = "XPERIA";
      }
      //进行DI品类校验
      let url = api.reservation.getCheckDI();
      http({
        method: "POST",
        url: url,
        data: {
          modelCode: productModel,
        },
      })
        .then((res) => {
          if (res.data.data != 1) {
            this.modelCode = "";
            this.$toast({
              show: true,
              message: "本型号暂未开通到店服务,不允许继续填入及提交",
              position: "top",
              during: 3000,
            });
          } else {
            this.modelCode = productModel;
            this.serialNum = serialNumber;
            this.regProductFlag = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    homePageAA() {
      console.log('AA', this.$route.path, this.$route.name);
      window.digitalData = {
        page: {
          pageInfo: {
            pageURL: window.location.href,
            pageName: 'best:' + this.$route.name,	//页面名称，必填变量
            pageTitle: 'best:' + this.$route.name,
            siteSection: "best"	//网站区域，必填
          }
        }
      };
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.getCondition();
      console.log(
        "BASE_PATH:",
        `${BASE_PATH}` === "development" || this.conditionFlag
          ? "66000"
          : "this.serviceSite"
      );
    });
  },

  beforeCreate() {
    if (isMobileDevice()) {
      console.log("is mobile device");
      window.location = "/mobilesite/index.html#/toShop";
    }
  },

  async created() {
    this.serviceType = this.serviceType1;
    this.refreshImg();
    this.weekList = sevenDays(8);
    // this.seletWeekDay(0, getDay(1, '-'))
    console.log("this.week:", this.weekList);
    // console.log("this.initAddress('China_StateNode.json'):", await this.initAddress('China_StateNode.json'))
    this.findProvince();
    this.getPersonalDetails();
    this.getRegPorductList();
    this.homePageAA();
  },
};
</script>
<style>
@import url("../assets/css/common.css");
@import url("../assets/css/index.css");

.reg-product {
  text-decoration: underline #00b0ec;
  color: #00b0ec;
  font-size: 15px;
  margin-top: 10px;
  cursor: pointer;
}

.select-wrap2 {
  width: 940px;
}

.select-wrap select {
  width: 200px;
  border: 1px solid rgba(216, 221, 225, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 10px;
  font-size: 15px;
  color: #576371;
  overflow-y: scroll;
}

.vercode {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #0190e1;
  cursor: pointer;
}

.vercode_disable {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #a4a4a4;
  cursor: pointer;
}

.qrcode-img {
  width: 150px;
  height: 150px;
}
</style>
